import { Group, Select, Switch, Text } from "@mantine/core";
import type { OrnamentVariant } from "../../api/ornaments";
import { BOW_COLORS, REMOVAL_MODES, bowColorHex } from "../../types/api";
import { ColorDot } from "../ui";

/** The ornament variant inputs (bow colour, background removal, removal mode), shared by Generate and the detail "add variant" form. */
export default function OrnamentVariantFields({
  value,
  onChange,
  disabled,
}: {
  value: OrnamentVariant;
  onChange: (value: OrnamentVariant) => void;
  disabled?: boolean;
}) {
  return (
    <>
      <Select
        label="Bow colour"
        value={value.bowColor}
        onChange={(v) => {
          if (v === null) throw new Error("Bow colour cannot be empty");
          onChange({ ...value, bowColor: v });
        }}
        data={BOW_COLORS.map((c) => ({ value: c.value, label: c.label }))}
        leftSection={<ColorDot color={bowColorHex(value.bowColor)} />}
        renderOption={({ option }) => (
          <Group gap="xs">
            <ColorDot color={bowColorHex(option.value)} />
            <Text size="sm">{option.label}</Text>
          </Group>
        )}
        allowDeselect={false}
        disabled={disabled}
      />
      <Switch
        label="Remove background"
        description="Cut the subject out so it floats inside the ball; otherwise the photo is centre-cropped to a disc"
        checked={value.removeBackground}
        onChange={(e) => onChange({ ...value, removeBackground: e.currentTarget.checked })}
        disabled={disabled}
      />
      <Select
        label="Removal mode"
        description="Used only when the background is removed"
        value={value.removalMode}
        onChange={(v) => {
          if (v === null) throw new Error("Removal mode cannot be empty");
          onChange({ ...value, removalMode: v });
        }}
        data={REMOVAL_MODES}
        allowDeselect={false}
        disabled={disabled || !value.removeBackground}
      />
    </>
  );
}
